import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-root',
	templateUrl: 'app.component.html',
	styleUrls: ['app.component.scss'],
})
export class AppComponent{
	constructor(
		private route: ActivatedRoute,
	) {
		localStorage.setItem('token', '');
		this.route.queryParams.subscribe(params => {
			const token = params['token'];
			if(token){
				localStorage.setItem('token', token);
			}
			
		});
	}


}
